const formatTechnologyType = (name: string): string => {
  let newNameArray = name.toLowerCase().split('_')
  let newName = newNameArray.join(' ')

  return newName[0].toUpperCase() + newName.slice(1)
}

export default formatTechnologyType
